import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import CssBaseline from '@mui/material/CssBaseline';
import store from './app/store';
import { Provider } from 'react-redux';
import { CustomThemeProvider } from './components/global/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>

    <Provider store={store}>
        <CustomThemeProvider>
            <CssBaseline />
            <App />
        </CustomThemeProvider>
    </Provider>
    // </React.StrictMode>
);
